"use client";

import { ArrowUpFull } from "../../icons/arrow-up-full";

export default function BackToTopLink({
  anchorId,
  className,
  offset = 96,
}: {
  anchorId: string;
  className?: string;
  offset?: number;
}) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.getElementById(anchorId);
    if (target) {
      const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
      window.history.pushState(null, "", `#${anchorId}`);
      return;
    }
    window.location.hash = anchorId;
  };

  return (
    <a
      href={`#${anchorId}`}
      onClick={handleClick}
      className={className}
    >
      <ArrowUpFull className="h-4 w-4 text-current" />
      <span>Back to top</span>
    </a>
  );
}
